import { useFocusEffect } from '@react-navigation/native';
import { useQueryClient } from '@tanstack/react-query';
import { setBadgeCountAsync } from 'expo-notifications';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { TabRoute } from '@/navigation/types/navigation';
import { useBadgeStore } from '@/shared/store/useBadgeStore';

export const useMeinOrtBadgeLifecycle = () => {
  const queryClient = useQueryClient();
  const newPostBadgeEntriesChanged = useBadgeStore(
    (state) => state.newPostBadgeEntriesChanged
  );
  const updateNewPostBadgeEntriesChanged = useBadgeStore(
    (state) => state.updateNewPostBadgeEntriesChanged
  );
  const expirePostBadgeEntries = useBadgeStore(
    (state) => state.expirePostBadgeEntries
  );
  const updateBadge = useBadgeStore((state) => state.updateBadge);

  useFocusEffect(
    useCallback(() => {
      if (newPostBadgeEntriesChanged) {
        queryClient.invalidateQueries({
          queryKey: [API_CACHE_KEYS.POST_FEED]
        });
        queryClient.invalidateQueries({
          queryKey: [API_CACHE_KEYS.MEIN_ORT_POST_FEED]
        });
        updateNewPostBadgeEntriesChanged(false);
      }
      expirePostBadgeEntries();
      // oxlint-disable-next-line unicorn/no-useless-undefined
      updateBadge(TabRoute.Radio, undefined);
      setBadgeCountAsync(0);
    }, [
      expirePostBadgeEntries,
      newPostBadgeEntriesChanged,
      queryClient,
      updateBadge,
      updateNewPostBadgeEntriesChanged
    ])
  );
};
